import React from "react";
import "../assets/AlertCard.css";

export default function AlertCard({ alert }) {
  if (!alert) {
    return <div className="alert-card">Nessun alert disponibile</div>;
  }

  return (
    <div className="alert-card glass-effect">
      <h3 className="alert-card__title">Nuovo Alert</h3>
      <p>{alert.client} <strong className="alert-card_element-head">: Cliente</strong></p>
      <p>{alert.product} <strong className="alert-card_element-head">: Prodotto</strong></p>
      <p>{alert.code} <strong className="alert-card_element-head">: Codice</strong></p>
    </div>
  );
}
